export const MOBILE_W = 850;
export const TABLET_W = 1280;

export const MOBILE_WIDTH = `max-width: ${MOBILE_W}px`;
export const TABLET_WIDTH = `max-width: ${TABLET_W}px`;
